(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-celimax-gift"] && !Shopify.designMode) return;
  try {
    
(() => {
  function streamSDK() {
    if (window.Stream) return Promise.resolve(window.Stream);
    if (!window.niaCelimaxStreamSDK) {
      window.niaCelimaxStreamSDK = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://embed.cloudflarestream.com/embed/sdk.latest.js';
        script.async = true;
        script.onload = () => window.Stream ? resolve(window.Stream) : reject(new Error('Player unavailable'));
        script.onerror = reject;
        document.head.append(script);
      });
    }
    return window.niaCelimaxStreamSDK;
  }

  function mount() {
    const root = document.querySelector('.nia-celimax-gift.mp-mode-story');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    let destroyed = false;
    const cleanups = [];
    const product = document.querySelector('product-info');
    const prompt = root.querySelector('[data-mp-prompt]');
    const sync = () => {
      const form = product?.querySelector('#es-form');
      const row = form?.querySelector('.es-first_name-group');
      if (row && prompt && !form.querySelector('.mp-delivery-prompt')) row.before(prompt.content.cloneNode(true));
      const gift = root.querySelector('[data-mp-order-gift]');
      const title = form?.querySelector('.nia-form-title');
      if (form && gift && !form.querySelector('.mp-order-gift')) {
        const node = gift.content.cloneNode(true);
        if (title) title.after(node); else form.prepend(node);
      }
    };
    sync();
    if (product) {
      const observer = new MutationObserver(sync);
      observer.observe(product, { childList: true, subtree: true });
      cleanups.push(() => observer.disconnect());
    }

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const frames = [...root.querySelectorAll('[data-mp-video]')];
    // Frames and small posters start loading from HTML, before the visitor reaches this section.
    streamSDK().then(Stream => {
      if (destroyed) return;
      const states = new Map();
      const reveal = frame => frame.parentElement.classList.add('mp-video-ready');
      const update = state => {
        if (state.visible && !document.hidden) {
          state.autoPause = false;
          if (!reduce && !state.userPaused) {
            Promise.resolve(state.player.play()).catch(() => reveal(state.frame));
          }
        } else {
          state.autoPause = true;
          state.player.pause();
        }
      };
      frames.forEach(frame => {
        const player = Stream(frame);
        const state = { frame, player, visible: false, autoPause: true, userPaused: false };
        states.set(frame, state);
        player.muted = true;
        player.loop = true;
        if (reduce) reveal(frame);
        player.addEventListener('loadeddata', () => reveal(frame));
        player.addEventListener('playing', () => {
          reveal(frame);
          if (!state.visible || document.hidden) {
            state.autoPause = true;
            player.pause();
          }
        });
        player.addEventListener('pause', () => {
          if (state.visible && !document.hidden && !state.autoPause) state.userPaused = true;
        });
        player.addEventListener('play', () => { state.userPaused = false; });
        player.addEventListener('error', () => reveal(frame));
        frame.addEventListener('load', () => {
          player.muted = true;
          update(state);
        });
      });
      const visibility = new IntersectionObserver(entries => entries.forEach(entry => {
        const state = states.get(entry.target);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        update(state);
      }), { threshold: [0, 0.2, 0.6] });
      frames.forEach(frame => visibility.observe(frame));
      const onVisibility = () => states.forEach(update);
      document.addEventListener('visibilitychange', onVisibility);
      cleanups.push(() => {
        visibility.disconnect();
        document.removeEventListener('visibilitychange', onVisibility);
        states.forEach(state => state.player.pause());
      });
    }).catch(error => {
      if (destroyed) return;
      console.warn('NIA video controls unavailable:', error?.message || 'SDK failed to load');
      // Native player controls remain usable if the optional control SDK is blocked.
      frames.forEach(frame => frame.parentElement.classList.add('mp-video-ready'));
    });

    root.querySelectorAll('[data-mp-carousel]').forEach(carousel => {
      let stopped = reduce;
      const stop = () => { stopped = true; };
      ['pointerdown', 'keydown', 'wheel'].forEach(event => carousel.addEventListener(event, stop, { once: true }));
      const timer = setInterval(() => {
        if (stopped || document.hidden) return;
        const bounds = carousel.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > innerHeight) return;
        const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
        const step = carousel.firstElementChild.getBoundingClientRect().width + gap;
        const max = carousel.scrollWidth - carousel.clientWidth;
        carousel.scrollTo({ left: carousel.scrollLeft >= max - 4 ? 0 : Math.min(max, carousel.scrollLeft + step), behavior: 'smooth' });
      }, 1500);
      cleanups.push(() => clearInterval(timer));
    });
    const unload = event => {
      if (!event.target.contains(root)) return;
      destroyed = true;
      cleanups.forEach(cleanup => cleanup());
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-funnel-details"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('product-info[id^="MainProduct"]').forEach((product) => {
      if (product.dataset.niaOrderBound) return;
      product.dataset.niaOrderBound = 'true';
      let title = product.querySelector('.nia-form-title');
      let picker = product.querySelector('variant-selects');
      let queued = false;
      let observedForm;
      const mobileOrder = document.querySelector('.nia-mobile-order');
      const orderVisibility = mobileOrder && 'IntersectionObserver' in window
        ? new IntersectionObserver(([entry]) => document.querySelector('.nia-mobile-order')?.classList.toggle('is-hidden', entry.isIntersecting))
        : null;
      const arrange = () => {
        queued = false;
        const form = product.querySelector('#es-form');
        const cta = form?.querySelector('.es-cta-group');
        if (!form || !cta) return;
        if (orderVisibility && observedForm !== form) {
          orderVisibility.disconnect();
          observedForm = form;
          orderVisibility.observe(form);
        }
        title = product.querySelector('.nia-form-title') || title;
        picker = product.querySelector('variant-selects') || picker;
        if (title && form.firstElementChild !== title) form.prepend(title);
        const name = form.querySelector('.es-first_name-group');
        const phone = form.querySelector('.es-phone-group');
        if (name && phone && name.nextElementSibling !== phone) name.after(phone);
        if (picker && title && title.nextElementSibling !== picker) title.after(picker);
        form.classList.toggle('nia-order-ready', Boolean(picker));
        if(title?.dataset.niaButton){
          const orderButton=form.querySelector('#es-form-button');
          if(orderButton && orderButton.style.getPropertyValue('background-color')!=='var(--nia-button-bg)'){
            orderButton.style.setProperty('background-color','var(--nia-button-bg)','important');
            orderButton.style.setProperty('color','var(--nia-button-text)','important');
            orderButton.querySelectorAll('.es-button-content *').forEach(el=>el.style.setProperty('color','var(--nia-button-text)','important'));
          }
          const buttonTitle=form.querySelector('#es-form-button .es-button-content>div:last-child>span');
          const subtitle=form.querySelector('#es-form-button .es-button-subtitle');
          if(buttonTitle&&buttonTitle.textContent!==title.dataset.niaButton)buttonTitle.textContent=title.dataset.niaButton;
          if(subtitle&&subtitle.textContent!==title.dataset.niaButtonSubtitle)subtitle.textContent=title.dataset.niaButtonSubtitle;
          [['.es-first_name-group','niaName'],['.es-phone-group','niaPhone'],['.es-city-group','niaCity'],['.es-address-group','niaAddress']].forEach(([sel,key])=>{const input=form.querySelector(sel+' input');if(input&&title.dataset[key]){input.placeholder=title.dataset[key];input.setAttribute('aria-label',title.dataset[key]);}});
        }
      };
      const observer = new MutationObserver(() => {
        if (!queued) { queued = true; requestAnimationFrame(arrange); }
      });
      observer.observe(product, { childList: true, subtree: true });
      arrange();
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(product)) {
          observer.disconnect();
          orderVisibility?.disconnect();
          mobileOrder?.classList.remove('is-hidden');
        }
      }, { once: true });
    });
  };

  const initMedia = (scope = document) => {
    scope.querySelectorAll('[data-nia-carousel]').forEach((carousel) => {
      if (carousel.dataset.niaReady) return;
      carousel.dataset.niaReady = 'true';
      const track = carousel.querySelector('.nia-carousel-track');
      const slides = [...track.children];
      const prev = carousel.querySelector('[data-nia-prev]');
      const next = carousel.querySelector('[data-nia-next]');
      const count = carousel.querySelector('[data-nia-count]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const signal = controller.signal;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.dataset.niaAutoplayToggle = '';
      toggle.setAttribute('aria-controls', track.id);
      carousel.append(toggle);
      let inView = false;
      let paused = false;
      let timer;
      const stepSize = () => (slides[0]?.getBoundingClientRect().width || 1) + (parseFloat(getComputedStyle(track).gap) || 0);
      const scroll = (left) => track.scrollTo({left, behavior:motion.matches ? 'auto' : 'smooth'});
      const syncAutoplay = () => {
        const stopped = paused || motion.matches;
        toggle.disabled = motion.matches || slides.length < 2;
        toggle.textContent = stopped ? '▶' : 'Ⅱ';
        toggle.setAttribute('aria-label', motion.matches ? 'Défilement automatique désactivé' : (paused ? 'Reprendre le défilement automatique' : 'Mettre le défilement en pause'));
        count?.setAttribute('aria-live', stopped ? 'polite' : 'off');
        const playing = !stopped && inView && !document.hidden && track.scrollWidth > track.clientWidth + 2;
        carousel.dataset.niaAutoplay = playing ? 'playing' : (stopped ? 'paused' : 'idle');
        if (!playing) { clearInterval(timer); timer = undefined; return; }
        if (timer !== undefined) return;
        timer = setInterval(() => {
          const end = track.scrollWidth - track.clientWidth;
          scroll(track.scrollLeft >= end - 3 ? 0 : Math.min(end, track.scrollLeft + stepSize()));
        }, Number(carousel.closest('[data-nia-interval]')?.dataset.niaInterval) || 1500);
      };
      const stop = () => { paused = true; syncAutoplay(); };
      const update = () => {
        const current = Math.min(slides.length, Math.round(track.scrollLeft / stepSize()) + 1);
        count.textContent = current + ' / ' + slides.length;
        carousel.querySelectorAll('[data-nia-slide]').forEach((button, index) => {
          if(index === current - 1) button.setAttribute('aria-current','true');
          else button.removeAttribute('aria-current');
        });
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      carousel.querySelectorAll('[data-nia-slide]').forEach(button => button.addEventListener('click', () => {
        stop(); scroll(Number(button.dataset.niaSlide) * stepSize());
      }, {signal}));
      const move = (direction) => {
        stop();
        scroll(track.scrollLeft + direction * stepSize());
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      toggle.addEventListener('click', () => { paused = !paused; syncAutoplay(); }, {signal});
      let pointerStart;
      let gestureMoved = false;
      carousel.addEventListener('pointerdown', (event) => {
        pointerStart = {x:event.clientX,y:event.clientY};
        gestureMoved = false;
      }, {passive:true,signal});
      carousel.addEventListener('pointermove', (event) => {
        if (!pointerStart) return;
        const dx = Math.abs(event.clientX - pointerStart.x);
        const dy = Math.abs(event.clientY - pointerStart.y);
        if (Math.max(dx,dy) < 10) return;
        gestureMoved = true;
        if (dx > dy) stop();
      }, {passive:true,signal});
      carousel.addEventListener('pointerup', () => {pointerStart = undefined;}, {passive:true,signal});
      carousel.addEventListener('pointercancel', () => {pointerStart = undefined;gestureMoved = true;}, {passive:true,signal});
      carousel.addEventListener('click', (event) => {
        if (!gestureMoved && !event.target.closest('[data-nia-autoplay-toggle]')) stop();
      }, {signal});
      carousel.addEventListener('focusin', (event) => {
        if (event.target.matches(':focus-visible') && !event.target.closest('[data-nia-autoplay-toggle]')) stop();
      }, {signal});
      track.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) stop();
      }, {passive:true,signal});
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
      }, {signal});
      track.addEventListener('scroll', update, {passive:true,signal});
      document.addEventListener('visibilitychange', syncAutoplay, {signal});
      motion.addEventListener('change', syncAutoplay, {signal});
      const sizeObserver = new ResizeObserver(() => {update();syncAutoplay();});
      sizeObserver.observe(track);
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        syncAutoplay();
      }, {threshold:0,rootMargin:'-70px 0px -60px 0px'});
      visibilityObserver.observe(track);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(carousel)) return;
        clearInterval(timer);
        sizeObserver.disconnect();
        visibilityObserver.disconnect();
        controller.abort();
      }, {signal});
      update();
      syncAutoplay();
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const load = (frame) => {
      if (!frame.dataset.src) return;
      frame.src = reduced ? frame.dataset.src.replace('autoplay=true','autoplay=false') : frame.dataset.src;
      delete frame.dataset.src;
    };
    const frames = [...scope.querySelectorAll('iframe.nia-lazy-video[data-src]')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach(entry => {if(entry.isIntersecting){load(entry.target);observer.unobserve(entry.target);}}), {rootMargin:'200px'});
      frames.forEach(frame => observer.observe(frame));
    } else frames.forEach(load);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initMedia(), {once:true});
  else initMedia();
  document.addEventListener('shopify:section:load', event => initMedia(event.target));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', () => {
    init();
    const form = document.querySelector('#es-form');
    const rect = form?.getBoundingClientRect();
    document.querySelector('.nia-mobile-order')?.classList.toggle('is-hidden', Boolean(rect && rect.bottom > 0 && rect.top < innerHeight));
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-funnel-header"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=(scope=document)=>{
  const bar=scope.querySelector('[data-nia-custom-flash]');
  if(!bar||bar.dataset.ready) return;
  bar.dataset.ready='true';
  const spacer=bar.nextElementSibling,deadline=Date.parse(bar.dataset.endsAt),digits=[...bar.querySelectorAll('[data-nia-digit]')];
  const resize=()=>{const h=bar.hidden?0:bar.offsetHeight;spacer.style.height=h+'px';document.documentElement.style.setProperty('--nia-flash-height',h+'px');};
  if(!bar.dataset.endsAt.trim()){
    bar.querySelector('.nia-flash__countdown').hidden=true;
    bar.querySelector('.nia-flash__countdown').style.display='none';
    bar.querySelector('.nia-flash__inner').style.gridTemplateColumns='minmax(0,1fr) auto';
    bar.querySelector('.nia-flash__cta').style.gridColumn='2';
    resize();new ResizeObserver(resize).observe(bar);return;
  }
  let timer; const update=()=>{const r=Math.max(0,Math.ceil((deadline-Date.now())/1000));if(!Number.isFinite(r)||r<=0){bar.hidden=true;clearInterval(timer);resize();return;} [Math.floor(r/86400),Math.floor(r%86400/3600),Math.floor(r%3600/60),r%60].forEach((v,i)=>digits[i].textContent=String(v).padStart(2,'0'));resize();};
  update();if(!bar.hidden) timer=setInterval(update,1000);const ro=new ResizeObserver(resize);ro.observe(bar);
  document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(bar)){clearInterval(timer);ro.disconnect();}},{once:true});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-kormesic-studio"] && !Shopify.designMode) return;
  try {
    
(()=>{function mount(){const root=document.querySelector('.nia-kormesic-studio.kl-section-story');if(!root||root.dataset.mounted)return;root.dataset.mounted='1';const product=document.querySelector('product-info');const sync=()=>{const form=product?.querySelector('#es-form'),row=form?.querySelector('.es-first_name-group'),t=root.querySelector('[data-kl-prompt]');if(row&&t&&!form.querySelector('.kl-delivery-prompt'))row.before(t.content.cloneNode(true));};sync();if(product)new MutationObserver(sync).observe(product,{childList:true,subtree:true});const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;const io=new IntersectionObserver(es=>es.forEach(e=>{const v=e.target;if(e.isIntersecting){const source=v.querySelector('source');if(source.dataset.src){source.src=source.dataset.src;delete source.dataset.src;v.load();}if(!reduce&&!v.dataset.userPaused){v.muted=true;v.play().catch(()=>{});}}else v.pause();}),{threshold:.2});document.querySelectorAll('[data-kl-video]').forEach(v=>{io.observe(v);v.addEventListener('pointerdown',()=>v.dataset.userPaused='1');});document.querySelectorAll('[data-kl-carousel]').forEach(c=>{let stopped=reduce;c.addEventListener('pointerdown',()=>stopped=true,{once:true});c.addEventListener('keydown',()=>stopped=true,{once:true});setInterval(()=>{if(stopped||document.hidden)return;const r=c.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;const card=c.firstElementChild;if(!card)return;const step=card.getBoundingClientRect().width+20;c.scrollTo({left:c.scrollLeft+step>=c.scrollWidth-c.clientWidth-2?0:c.scrollLeft+step,behavior:'smooth'});},1500);});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();document.addEventListener('shopify:section:load',mount);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-medicube-nad"] && !Shopify.designMode) return;
  try {
    
(() => {
  function streamSDK() {
    if (window.Stream) return Promise.resolve(window.Stream);
    if (!window.niaMedicubeNadStreamSDK) {
      window.niaMedicubeNadStreamSDK = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://embed.cloudflarestream.com/embed/sdk.latest.js';
        script.async = true;
        script.onload = () => window.Stream ? resolve(window.Stream) : reject(new Error('Player unavailable'));
        script.onerror = reject;
        document.head.append(script);
      });
    }
    return window.niaMedicubeNadStreamSDK;
  }

  function mount() {
    const root = document.querySelector('.nia-medicube-nad.mp-mode-story');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    let destroyed = false;
    const cleanups = [];
    const product = document.querySelector('product-info');
    const prompt = root.querySelector('[data-mp-prompt]');
    const sync = () => {
      const form = product?.querySelector('#es-form');
      const row = form?.querySelector('.es-first_name-group');
      if (row && prompt && !form.querySelector('.mp-delivery-prompt')) row.before(prompt.content.cloneNode(true));
      const gift = root.querySelector('[data-mp-order-gift]');
      const title = form?.querySelector('.nia-form-title');
      if (form && gift && !form.querySelector('.mp-order-gift')) {
        const node = gift.content.cloneNode(true);
        if (title) title.after(node); else form.prepend(node);
      }
    };
    sync();
    if (product) {
      const observer = new MutationObserver(sync);
      observer.observe(product, { childList: true, subtree: true });
      cleanups.push(() => observer.disconnect());
    }

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const frames = [...root.querySelectorAll('[data-mp-video]')];
    // Frames and small posters start loading from HTML, before the visitor reaches this section.
    streamSDK().then(Stream => {
      if (destroyed) return;
      const states = new Map();
      const reveal = frame => frame.parentElement.classList.add('mp-video-ready');
      const update = state => {
        if (state.visible && !document.hidden) {
          state.autoPause = false;
          if (!reduce && !state.userPaused) {
            Promise.resolve(state.player.play()).catch(() => reveal(state.frame));
          }
        } else {
          state.autoPause = true;
          state.player.pause();
        }
      };
      frames.forEach(frame => {
        const player = Stream(frame);
        const state = { frame, player, visible: false, autoPause: true, userPaused: false };
        states.set(frame, state);
        player.muted = true;
        player.loop = true;
        if (reduce) reveal(frame);
        player.addEventListener('loadeddata', () => reveal(frame));
        player.addEventListener('playing', () => {
          reveal(frame);
          if (!state.visible || document.hidden) {
            state.autoPause = true;
            player.pause();
          }
        });
        player.addEventListener('pause', () => {
          if (state.visible && !document.hidden && !state.autoPause) state.userPaused = true;
        });
        player.addEventListener('play', () => { state.userPaused = false; });
        player.addEventListener('error', () => reveal(frame));
        frame.addEventListener('load', () => {
          player.muted = true;
          update(state);
        });
      });
      const visibility = new IntersectionObserver(entries => entries.forEach(entry => {
        const state = states.get(entry.target);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        update(state);
      }), { threshold: [0, 0.2, 0.6] });
      frames.forEach(frame => visibility.observe(frame));
      const onVisibility = () => states.forEach(update);
      document.addEventListener('visibilitychange', onVisibility);
      cleanups.push(() => {
        visibility.disconnect();
        document.removeEventListener('visibilitychange', onVisibility);
        states.forEach(state => state.player.pause());
      });
    }).catch(error => {
      if (destroyed) return;
      console.warn('NIA video controls unavailable:', error?.message || 'SDK failed to load');
      // Native player controls remain usable if the optional control SDK is blocked.
      frames.forEach(frame => frame.parentElement.classList.add('mp-video-ready'));
    });

    root.querySelectorAll('[data-mp-carousel]').forEach(carousel => {
      let stopped = reduce;
      const stop = () => { stopped = true; };
      ['pointerdown', 'keydown', 'wheel'].forEach(event => carousel.addEventListener(event, stop, { once: true }));
      const timer = setInterval(() => {
        if (stopped || document.hidden) return;
        const bounds = carousel.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > innerHeight) return;
        const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
        const step = carousel.firstElementChild.getBoundingClientRect().width + gap;
        const max = carousel.scrollWidth - carousel.clientWidth;
        carousel.scrollTo({ left: carousel.scrollLeft >= max - 4 ? 0 : Math.min(max, carousel.scrollLeft + step), behavior: 'smooth' });
      }, 1500);
      cleanups.push(() => clearInterval(timer));
    });
    const unload = event => {
      if (!event.target.contains(root)) return;
      destroyed = true;
      cleanups.forEach(cleanup => cleanup());
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-medicube-pack"] && !Shopify.designMode) return;
  try {
    
(() => {
  function streamSDK() {
    if (window.Stream) return Promise.resolve(window.Stream);
    if (!window.niaMedicubeStreamSDK) {
      window.niaMedicubeStreamSDK = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://embed.cloudflarestream.com/embed/sdk.latest.js';
        script.async = true;
        script.onload = () => window.Stream ? resolve(window.Stream) : reject(new Error('Player unavailable'));
        script.onerror = reject;
        document.head.append(script);
      });
    }
    return window.niaMedicubeStreamSDK;
  }

  function mount() {
    const root = document.querySelector('.nia-medicube-pack.mp-mode-story');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    let destroyed = false;
    const cleanups = [];
    const product = document.querySelector('product-info');
    const prompt = root.querySelector('[data-mp-prompt]');
    const sync = () => {
      const form = product?.querySelector('#es-form');
      const row = form?.querySelector('.es-first_name-group');
      if (row && prompt && !form.querySelector('.mp-delivery-prompt')) row.before(prompt.content.cloneNode(true));
      const gift = root.querySelector('[data-mp-order-gift]');
      const title = form?.querySelector('.nia-form-title');
      if (form && gift && !form.querySelector('.mp-order-gift')) {
        const node = gift.content.cloneNode(true);
        if (title) title.after(node); else form.prepend(node);
      }
    };
    sync();
    if (product) {
      const observer = new MutationObserver(sync);
      observer.observe(product, { childList: true, subtree: true });
      cleanups.push(() => observer.disconnect());
    }

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const frames = [...root.querySelectorAll('[data-mp-video]')];
    // Frames and small posters start loading from HTML, before the visitor reaches this section.
    streamSDK().then(Stream => {
      if (destroyed) return;
      const states = new Map();
      const reveal = frame => frame.parentElement.classList.add('mp-video-ready');
      const update = state => {
        if (state.visible && !document.hidden) {
          state.autoPause = false;
          if (!reduce && !state.userPaused) {
            Promise.resolve(state.player.play()).catch(() => reveal(state.frame));
          }
        } else {
          state.autoPause = true;
          state.player.pause();
        }
      };
      frames.forEach(frame => {
        const player = Stream(frame);
        const state = { frame, player, visible: false, autoPause: true, userPaused: false };
        states.set(frame, state);
        player.muted = true;
        player.loop = true;
        if (reduce) reveal(frame);
        player.addEventListener('loadeddata', () => reveal(frame));
        player.addEventListener('playing', () => {
          reveal(frame);
          if (!state.visible || document.hidden) {
            state.autoPause = true;
            player.pause();
          }
        });
        player.addEventListener('pause', () => {
          if (state.visible && !document.hidden && !state.autoPause) state.userPaused = true;
        });
        player.addEventListener('play', () => { state.userPaused = false; });
        player.addEventListener('error', () => reveal(frame));
        frame.addEventListener('load', () => {
          player.muted = true;
          update(state);
        });
      });
      const visibility = new IntersectionObserver(entries => entries.forEach(entry => {
        const state = states.get(entry.target);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        update(state);
      }), { threshold: [0, 0.2, 0.6] });
      frames.forEach(frame => visibility.observe(frame));
      const onVisibility = () => states.forEach(update);
      document.addEventListener('visibilitychange', onVisibility);
      cleanups.push(() => {
        visibility.disconnect();
        document.removeEventListener('visibilitychange', onVisibility);
        states.forEach(state => state.player.pause());
      });
    }).catch(error => {
      if (destroyed) return;
      console.warn('NIA video controls unavailable:', error?.message || 'SDK failed to load');
      // Native player controls remain usable if the optional control SDK is blocked.
      frames.forEach(frame => frame.parentElement.classList.add('mp-video-ready'));
    });

    root.querySelectorAll('[data-mp-carousel]').forEach(carousel => {
      let stopped = reduce;
      const stop = () => { stopped = true; };
      ['pointerdown', 'keydown', 'wheel'].forEach(event => carousel.addEventListener(event, stop, { once: true }));
      const timer = setInterval(() => {
        if (stopped || document.hidden) return;
        const bounds = carousel.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > innerHeight) return;
        const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
        const step = carousel.firstElementChild.getBoundingClientRect().width + gap;
        const max = carousel.scrollWidth - carousel.clientWidth;
        carousel.scrollTo({ left: carousel.scrollLeft >= max - 4 ? 0 : Math.min(max, carousel.scrollLeft + step), behavior: 'smooth' });
      }, 1500);
      cleanups.push(() => clearInterval(timer));
    });
    const unload = event => {
      if (!event.target.contains(root)) return;
      destroyed = true;
      cleanups.forEach(cleanup => cleanup());
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-nad-studio"] && !Shopify.designMode) return;
  try {
    
(()=>{function mount(){const root=document.querySelector('.nia-nad-studio.nd-section-story');if(!root||root.dataset.mounted)return;root.dataset.mounted='true';const product=document.querySelector('product-info');const sync=()=>{const form=product?.querySelector('#es-form'),row=form?.querySelector('.es-first_name-group'),template=root.querySelector('[data-nd-prompt]');if(row&&template&&!form.querySelector('.nd-delivery-prompt'))row.before(template.content.cloneNode(true));};sync();const observer=new MutationObserver(sync);if(product)observer.observe(product,{childList:true,subtree:true});const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.src=e.target.dataset.ndSrc;io.unobserve(e.target);}}),{rootMargin:'250px'});document.querySelectorAll('.nia-nad-studio iframe[data-nd-src]').forEach(f=>io.observe(f));document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){observer.disconnect();io.disconnect();}},{once:true});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();document.addEventListener('shopify:section:load',mount);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-product-funnel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('product-info[id^="MainProduct"]').forEach((product) => {
      if (product.dataset.niaOrderBound) return;
      product.dataset.niaOrderBound = 'true';
      let title = product.querySelector('.nia-form-title');
      let picker = product.querySelector('variant-selects');
      let queued = false;
      let observedForm;
      const mobileOrder = document.querySelector('.nia-mobile-order');
      const orderVisibility = mobileOrder && 'IntersectionObserver' in window
        ? new IntersectionObserver(([entry]) => mobileOrder.classList.toggle('is-hidden', entry.isIntersecting))
        : null;
      const arrange = () => {
        queued = false;
        const form = product.querySelector('#es-form');
        const cta = form?.querySelector('.es-cta-group');
        if (!form || !cta) return;
        if (orderVisibility && observedForm !== form) {
          orderVisibility.disconnect();
          observedForm = form;
          orderVisibility.observe(form);
        }
        title = product.querySelector('.nia-form-title') || title;
        picker = product.querySelector('variant-selects') || picker;
        if (title && form.firstElementChild !== title) form.prepend(title);
        const name = form.querySelector('.es-first_name-group');
        const phone = form.querySelector('.es-phone-group');
        if (name && phone && name.nextElementSibling !== phone) name.after(phone);
        if (picker && title && title.nextElementSibling !== picker) title.after(picker);
        form.classList.toggle('nia-order-ready', Boolean(picker));
      };
      const observer = new MutationObserver(() => {
        if (!queued) { queued = true; requestAnimationFrame(arrange); }
      });
      observer.observe(product, { childList: true, subtree: true });
      arrange();
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(product)) {
          observer.disconnect();
          orderVisibility?.disconnect();
          mobileOrder?.classList.remove('is-hidden');
        }
      }, { once: true });
    });
  };

  const initMedia = (scope = document) => {
    scope.querySelectorAll('[data-nia-carousel]').forEach((carousel) => {
      if (carousel.dataset.niaReady) return;
      carousel.dataset.niaReady = 'true';
      const track = carousel.querySelector('.nia-carousel-track');
      const slides = [...track.children];
      const prev = carousel.querySelector('[data-nia-prev]');
      const next = carousel.querySelector('[data-nia-next]');
      const count = carousel.querySelector('[data-nia-count]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const signal = controller.signal;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.dataset.niaAutoplayToggle = '';
      toggle.setAttribute('aria-controls', track.id);
      carousel.append(toggle);
      let inView = false;
      let paused = false;
      let timer;
      const stepSize = () => (slides[0]?.getBoundingClientRect().width || 1) + (parseFloat(getComputedStyle(track).gap) || 0);
      const scroll = (left) => track.scrollTo({left, behavior:motion.matches ? 'auto' : 'smooth'});
      const syncAutoplay = () => {
        const stopped = paused || motion.matches;
        toggle.disabled = motion.matches || slides.length < 2;
        toggle.textContent = stopped ? '▶' : 'Ⅱ';
        toggle.setAttribute('aria-label', motion.matches ? 'Défilement automatique désactivé' : (paused ? 'Reprendre le défilement automatique' : 'Mettre le défilement en pause'));
        count.setAttribute('aria-live', stopped ? 'polite' : 'off');
        const playing = !stopped && inView && !document.hidden && track.scrollWidth > track.clientWidth + 2;
        carousel.dataset.niaAutoplay = playing ? 'playing' : (stopped ? 'paused' : 'idle');
        if (!playing) { clearInterval(timer); timer = undefined; return; }
        if (timer !== undefined) return;
        timer = setInterval(() => {
          const end = track.scrollWidth - track.clientWidth;
          scroll(track.scrollLeft >= end - 3 ? 0 : Math.min(end, track.scrollLeft + stepSize()));
        }, 1500);
      };
      const stop = () => { paused = true; syncAutoplay(); };
      const update = () => {
        const current = Math.min(slides.length, Math.round(track.scrollLeft / stepSize()) + 1);
        count.textContent = current + ' / ' + slides.length;
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = (direction) => {
        stop();
        scroll(track.scrollLeft + direction * stepSize());
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      toggle.addEventListener('click', () => { paused = !paused; syncAutoplay(); }, {signal});
      let pointerStart;
      let gestureMoved = false;
      carousel.addEventListener('pointerdown', (event) => {
        pointerStart = {x:event.clientX,y:event.clientY};
        gestureMoved = false;
      }, {passive:true,signal});
      carousel.addEventListener('pointermove', (event) => {
        if (!pointerStart) return;
        const dx = Math.abs(event.clientX - pointerStart.x);
        const dy = Math.abs(event.clientY - pointerStart.y);
        if (Math.max(dx,dy) < 10) return;
        gestureMoved = true;
        if (dx > dy) stop();
      }, {passive:true,signal});
      carousel.addEventListener('pointerup', () => {pointerStart = undefined;}, {passive:true,signal});
      carousel.addEventListener('pointercancel', () => {pointerStart = undefined;gestureMoved = true;}, {passive:true,signal});
      carousel.addEventListener('click', (event) => {
        if (!gestureMoved && !event.target.closest('[data-nia-autoplay-toggle]')) stop();
      }, {signal});
      carousel.addEventListener('focusin', (event) => {
        if (event.target.matches(':focus-visible') && !event.target.closest('[data-nia-autoplay-toggle]')) stop();
      }, {signal});
      track.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) stop();
      }, {passive:true,signal});
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
      }, {signal});
      track.addEventListener('scroll', update, {passive:true,signal});
      document.addEventListener('visibilitychange', syncAutoplay, {signal});
      motion.addEventListener('change', syncAutoplay, {signal});
      const sizeObserver = new ResizeObserver(() => {update();syncAutoplay();});
      sizeObserver.observe(track);
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        syncAutoplay();
      }, {threshold:0,rootMargin:'-70px 0px -60px 0px'});
      visibilityObserver.observe(track);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(carousel)) return;
        clearInterval(timer);
        sizeObserver.disconnect();
        visibilityObserver.disconnect();
        controller.abort();
      }, {signal});
      update();
      syncAutoplay();
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const load = (frame) => {
      if (!frame.dataset.src) return;
      frame.src = reduced ? frame.dataset.src.replace('autoplay=true','autoplay=false') : frame.dataset.src;
      delete frame.dataset.src;
    };
    const frames = [...scope.querySelectorAll('iframe.nia-lazy-video[data-src]')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach(entry => {if(entry.isIntersecting){load(entry.target);observer.unobserve(entry.target);}}), {rootMargin:'200px'});
      frames.forEach(frame => observer.observe(frame));
    } else frames.forEach(load);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initMedia(), {once:true});
  else initMedia();
  document.addEventListener('shopify:section:load', event => initMedia(event.target));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-ptr-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
 const mount = () => {
  const section = document.querySelector('.nia-ptr-campaign');
  const source = section?.querySelector('template[data-np-delivery]');
  const product = document.querySelector('product-info');
  if (!source || !product || section.dataset.deliveryReady) return;
  section.dataset.deliveryReady = 'true';
  const sync = () => {
   const form = product.querySelector('#es-form');
   const row = form?.querySelector('.es-first_name-group');
   if (row && !form.querySelector('.np-delivery-prompt')) row.before(source.content.cloneNode(true));
  };
  sync();
  const observer = new MutationObserver(sync);
  observer.observe(product, { childList: true, subtree: true });
  document.addEventListener('shopify:section:unload', event => {
   if (event.target.contains(section)) observer.disconnect();
  }, { once: true });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
 document.addEventListener('shopify:section:load', mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-ptr-gift"] && !Shopify.designMode) return;
  try {
    
(() => {
  function streamSDK() {
    if (window.Stream) return Promise.resolve(window.Stream);
    if (!window.niaPtrGiftStreamSDK) {
      window.niaPtrGiftStreamSDK = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://embed.cloudflarestream.com/embed/sdk.latest.js';
        script.async = true;
        script.onload = () => window.Stream ? resolve(window.Stream) : reject(new Error('Player unavailable'));
        script.onerror = reject;
        document.head.append(script);
      });
    }
    return window.niaPtrGiftStreamSDK;
  }

  function mount() {
    const root = document.querySelector('.nia-ptr-gift.mp-mode-story');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    let destroyed = false;
    const cleanups = [];
    const product = document.querySelector('product-info');
    const prompt = root.querySelector('[data-mp-prompt]');
    const sync = () => {
      const form = product?.querySelector('#es-form');
      const row = form?.querySelector('.es-first_name-group');
      if (row && prompt && !form.querySelector('.mp-delivery-prompt')) row.before(prompt.content.cloneNode(true));
      const gift = root.querySelector('[data-mp-order-gift]');
      const title = form?.querySelector('.nia-form-title');
      if (form && gift && !form.querySelector('.mp-order-gift')) {
        const node = gift.content.cloneNode(true);
        if (title) title.after(node); else form.prepend(node);
      }
    };
    sync();
    if (product) {
      const observer = new MutationObserver(sync);
      observer.observe(product, { childList: true, subtree: true });
      cleanups.push(() => observer.disconnect());
    }

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const frames = [...root.querySelectorAll('[data-mp-video]')];
    // Frames and small posters start loading from HTML, before the visitor reaches this section.
    streamSDK().then(Stream => {
      if (destroyed) return;
      const states = new Map();
      const reveal = frame => frame.parentElement.classList.add('mp-video-ready');
      const update = state => {
        if (state.visible && !document.hidden) {
          state.autoPause = false;
          if (!reduce && !state.userPaused) {
            Promise.resolve(state.player.play()).catch(() => reveal(state.frame));
          }
        } else {
          state.autoPause = true;
          state.player.pause();
        }
      };
      frames.forEach(frame => {
        const player = Stream(frame);
        const state = { frame, player, visible: false, autoPause: true, userPaused: false };
        states.set(frame, state);
        player.muted = true;
        player.loop = true;
        if (reduce) reveal(frame);
        player.addEventListener('loadeddata', () => reveal(frame));
        player.addEventListener('playing', () => {
          reveal(frame);
          if (!state.visible || document.hidden) {
            state.autoPause = true;
            player.pause();
          }
        });
        player.addEventListener('pause', () => {
          if (state.visible && !document.hidden && !state.autoPause) state.userPaused = true;
        });
        player.addEventListener('play', () => { state.userPaused = false; });
        player.addEventListener('error', () => reveal(frame));
        frame.addEventListener('load', () => {
          player.muted = true;
          update(state);
        });
      });
      const visibility = new IntersectionObserver(entries => entries.forEach(entry => {
        const state = states.get(entry.target);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        update(state);
      }), { threshold: [0, 0.2, 0.6] });
      frames.forEach(frame => visibility.observe(frame));
      const onVisibility = () => states.forEach(update);
      document.addEventListener('visibilitychange', onVisibility);
      cleanups.push(() => {
        visibility.disconnect();
        document.removeEventListener('visibilitychange', onVisibility);
        states.forEach(state => state.player.pause());
      });
    }).catch(error => {
      if (destroyed) return;
      console.warn('NIA video controls unavailable:', error?.message || 'SDK failed to load');
      // Native player controls remain usable if the optional control SDK is blocked.
      frames.forEach(frame => frame.parentElement.classList.add('mp-video-ready'));
    });

    root.querySelectorAll('[data-mp-carousel]').forEach(carousel => {
      let stopped = reduce;
      const stop = () => { stopped = true; };
      ['pointerdown', 'keydown', 'wheel'].forEach(event => carousel.addEventListener(event, stop, { once: true }));
      const timer = setInterval(() => {
        if (stopped || document.hidden) return;
        const bounds = carousel.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > innerHeight) return;
        const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
        const step = carousel.firstElementChild.getBoundingClientRect().width + gap;
        const max = carousel.scrollWidth - carousel.clientWidth;
        carousel.scrollTo({ left: carousel.scrollLeft >= max - 4 ? 0 : Math.min(max, carousel.scrollLeft + step), behavior: 'smooth' });
      }, 1500);
      cleanups.push(() => clearInterval(timer));
    });
    const unload = event => {
      if (!event.target.contains(root)) return;
      destroyed = true;
      cleanups.forEach(cleanup => cleanup());
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-ptr-premium"] && !Shopify.designMode) return;
  try {
    
(() => {
 const mount = () => {
  const section = document.querySelector('.nia-ptr-premium.nx-story');
  const product = document.querySelector('product-info');
  if (!section || !product || section.dataset.ready) return;
  section.dataset.ready = 'true';
  const sync = () => {
   const form = product.querySelector('#es-form');
   const row = form?.querySelector('.es-first_name-group');
   const source = section.querySelector('template[data-nx-delivery]');
   if (row && source && !form.querySelector('.nx-delivery-prompt')) row.before(source.content.cloneNode(true));
  };
  sync(); const observer = new MutationObserver(sync); observer.observe(product,{childList:true,subtree:true});
  const videos = section.querySelectorAll('iframe[data-src]');
  const io = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.src=entry.target.dataset.src;io.unobserve(entry.target);}}),{rootMargin:'300px'});videos.forEach(frame=>io.observe(frame));
  document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(section)){observer.disconnect();io.disconnect();}},{once:true});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
 document.addEventListener('shopify:section:load',mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-vitalis-botanique"] && !Shopify.designMode) return;
  try {
    
(() => {
 const mount = () => {
  const section = document.querySelector('.nia-botanique');
  const source = section?.querySelector('template[data-nb-delivery]');
  const product = document.querySelector('product-info');
  if (!source || !product || section.dataset.deliveryReady) return;
  section.dataset.deliveryReady = 'true';
  const sync = () => {
   const form = product.querySelector('#es-form');
   const row = form?.querySelector('.es-first_name-group');
   if (row && !form.querySelector('.nb-delivery-prompt')) row.before(source.content.cloneNode(true));
  };
  sync();
  const observer = new MutationObserver(sync);
  observer.observe(product, { childList: true, subtree: true });
  document.addEventListener('shopify:section:unload', event => {
   if (event.target.contains(section)) observer.disconnect();
  }, { once: true });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
 document.addEventListener('shopify:section:load', mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nia-vitalis-signature"] && !Shopify.designMode) return;
  try {
    
(() => {
 const mount = () => {
  const section = document.querySelector('.nia-vitalis-signature');
  const source = section?.querySelector('template[data-nb-delivery]');
  const product = document.querySelector('product-info');
  if (!source || !product || section.dataset.deliveryReady) return;
  section.dataset.deliveryReady = 'true';
  const sync = () => {
   const form = product.querySelector('#es-form');
   const row = form?.querySelector('.es-first_name-group');
   if (row && !form.querySelector('.nb-delivery-prompt')) row.before(source.content.cloneNode(true));
  };
  sync();
  const observer = new MutationObserver(sync);
  observer.observe(product, { childList: true, subtree: true });
  document.addEventListener('shopify:section:unload', event => {
   if (event.target.contains(section)) observer.disconnect();
  }, { once: true });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
 document.addEventListener('shopify:section:load', mount);
})();

(() => {
 const init = () => document.querySelectorAll('.nia-vitalis-signature video, .vs-proof video').forEach(video => {
  if(video.dataset.vsReady) return; video.dataset.vsReady='1'; video.muted=true; video.playsInline=true;
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(entry.isIntersecting){video.preload='metadata';if(!video.dataset.userPaused) video.play().catch(()=>{});}
   else {video.dataset.offscreen='1';video.pause();}
  }),{threshold:.2,rootMargin:'100px'});
  video.addEventListener('play',()=>{delete video.dataset.offscreen;});
  video.addEventListener('pointerdown',()=>{video.dataset.userPaused='1';});
  observer.observe(video);
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
